import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Varnar när sidan lämnas med osparade ändringar, både vid navigering inne i appen och vid
 * stängd flik eller ändrad adress.
 *
 * useBlocker sköter navigeringen inne i appen och returneras, så att anroparen kan visa sin
 * egen dialog när state är 'blocked'. Webbläsarens egen dialog går inte att styra, därför
 * hanteras flikstängning separat med beforeunload.
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges: boolean) => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname);

  useEffect(() => {
    if (!hasUnsavedChanges) return undefined;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Krävs av äldre webbläsare för att dialogen ska visas.
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);

    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);

  return blocker;
};
